import { createQueryKeys } from '@lukemorales/query-key-factory';
import {
	getClientPortfolioConsiderations,
	getPortfolioConsiderations,
} from '@/app/api/portfolio-considerations';
import { PaginationQueryParams } from '@/app/api';

export const portfolioConsiderationsKeys = createQueryKeys('portfolio_considerations', {
	clientPortfolios: (clientId: string | number, { page, size }: PaginationQueryParams) => ({
		queryKey: ['clients', clientId, { page, size }],
		queryFn: () => getClientPortfolioConsiderations(clientId, { page, size }),
	}),
	allPortfolios: (clientId: string | number) => ({
		queryKey: ['all', clientId],
		queryFn: () => getPortfolioConsiderations(clientId),
	}),
});
